module.exports = __webpack_public_path__ + "assets/defaultBlue-ab99bd.svg";